import "core-js/stable";
import "regenerator-runtime/runtime";

let importPolyfills;

if (
  typeof Promise === "undefined" ||
  !Object.assign ||
  !window.fetch ||
  typeof global.requestAnimationFrame === "undefined" ||
  typeof global.cancelAnimationFrame === "undefined" ||
  typeof global.requestIdleCallback === "undefined" ||
  !global.Intl ||
  !global.Intl.PluralRules ||
  !global.Intl.RelativeTimeFormat ||
  !global.Intl.getCanonicalLocales
) {
  importPolyfills = import(
    /* webpackChunkName: "polyfill" */ "../../config/common/polyfills"
  );
} else {
  importPolyfills = Promise.resolve();
}

export default importPolyfills;
